/**
 * Get initials from a first name and last name.
 * @param {string} firstName
 * @param {string} lastName
 * @returns {string} Initials in uppercase
 */
export const getInitials = (firstName, lastName) => {
  const firstLetter = firstName ? firstName.charAt(0).toUpperCase() : '';
  const lastLetter = lastName ? lastName.charAt(0).toUpperCase() : '';
  return firstLetter + lastLetter;
};

export const getFirstLetter = (str) => {
  if (str && str.length > 0) {
    return str.charAt(0).toLowerCase(); // Convert the first letter to lowercase
  }
  return ''; // Return an empty string if the input is empty or undefined
}

export const numberToWord = (number) => {
  const numberWords = [
    'First', 'Second', 'Third', 'Fourth', 'Fifth', 
    'Sixth', 'Seventh', 'Eighth', 'Ninth'
  ];

  // Adjust for 1-based index
  if (number >= 1 && number <= 9) {
    return numberWords[number - 1];
  }

  return number; // Return null if the number is not in the range 1-9
};

export const toCamelCase = (str) => {
  return str
    .replace(/[^a-zA-Z0-9]+(.)/g, (match, group1) => group1.toUpperCase()) // Convert separators to uppercase letters
    .replace(/^(.)/, (match, group1) => group1.toLowerCase()); // Make the first letter lowercase
}

export const formatWeight = (value) => {
  if(value === '') {
    return '';
  }
  if(value <= 0) {
    return '0';
  }

  if (value.includes(".")) {
    const decimalPlaces = value.split(".")[1].length;
    if (decimalPlaces > 3) {
      return Math.floor(parseFloat(value) * 1000) / 1000;
    }
  }
  return parseFloat(value);
};

export const formatFileSize = (bytes) => {
  if (bytes < 1024) return `${bytes} bytes`;
  else if (bytes < 1048576) return `${(bytes / 1024).toFixed(2)} KB`;
  else if (bytes < 1073741824) return `${(bytes / 1048576).toFixed(2)} MB`;
  else return `${(bytes / 1073741824).toFixed(2)} GB`;
};

export const formatPhoneNumber = (value) => {
  const cleanedValue = value.replace(/\D/g, ''); // Remove non-digits
  let formattedValue = '';

  if (cleanedValue.length <= 3) {
    formattedValue = cleanedValue;
  } else if (cleanedValue.length <= 6) {
    formattedValue = `${cleanedValue.slice(0, 3)}-${cleanedValue.slice(3)}`;
  } else if (cleanedValue.length <= 10) {
    formattedValue = `${cleanedValue.slice(0, 3)}-${cleanedValue.slice(3, 6)}-${cleanedValue.slice(6)}`;
  } else {
    formattedValue = cleanedValue.slice(0, 10); // Limit to 10 digits
    formattedValue = `${formattedValue.slice(0, 3)}-${formattedValue.slice(3, 6)}-${formattedValue.slice(6)}`;
  }

  return formattedValue;
};